<template>
  <div class="relative" aria-hidden="true">
    <StaticAsset
      class="absolute top-0 z-[2]"
      folder="images"
      file="character-stills_04.png"
    />
    <StaticAsset
      class="absolute top-8 left-16 z-[2]"
      folder="images"
      file="character-stills_02.png"
    />
  </div>
</template>
